import createFieldArraySelect from 'pages/widgets/form/field-array-select'
import MatchHandleField from './twitter/match-handle'
import LikeOfAny from './twitter/like-of-any'
import TweetTypeField from './twitter/tweet-type-field'
import MatchHashtagField from './twitter/match-hashtag'
import MatchKeywordField from './twitter/match-keyword'
import MatchIntentField from './twitter/match-intent'
import TimeStampComponent from './common-triggers/send-at-specific-time'
import InstagramMentions from './instagram/mentions'
import InstagramHashtag from './instagram/hashtag'
import InstagramKeyword from './instagram/keyword'
import InstagramOnly from './instagram/only'
import InstagramCommentsOn from './instagram/comments-on-post'
import FacebookHashtag from './facebook/hashtag'
import FacebookKeyword from './facebook/keyword'
import FacebookOnly from './facebook/only'
import FacebookReaction from './facebook/reaction'
import FacebookCommentsOnPost from './facebook/comments-on-post'
import FacebookReactionOn from './facebook/reaction-on'

const TwitterTriggers = createFieldArraySelect({
  label: 'Select a trigger',
  options: {
    'Match handle': MatchHandleField,
    'Match hashtag': MatchHashtagField,
    'Match keyword': MatchKeywordField,
    'Match Intent': MatchIntentField,
    'Retweet of a Tweet': TweetTypeField,
    Like: TweetTypeField,
    'Like OR Retweet': TweetTypeField,
    'Like Of Any': LikeOfAny,
    "Owner's Tweet": null,
    'Send at specific time': TimeStampComponent,
    'Speed Thread Expired': null
  }
}).FieldItems

const InstagramTriggers = createFieldArraySelect({
  label: 'Select a trigger',
  options: {
    'Match Handle': InstagramMentions,
    'Match Hashtag': InstagramHashtag,
    'Match Keyword': InstagramKeyword,
    Only: InstagramOnly,
    'Comments On Post': InstagramCommentsOn
  }
}).FieldItems

const FacebookTriggers = createFieldArraySelect({
  label: 'Select a trigger',
  options: {
    'Match Hashtag': FacebookHashtag,
    'Match Keyword': FacebookKeyword,
    Only: FacebookOnly,
    'Match Reaction': FacebookReaction,
    'Comments On Post': FacebookCommentsOnPost,
    'Reaction On': FacebookReactionOn,
    'Received One-Time Consent': null,
    'Received Recurring Consent': null,
    'Send at specific time': TimeStampComponent
  }
}).FieldItems

export { TwitterTriggers, InstagramTriggers, FacebookTriggers }



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/index.js